import { Link } from "react-router-dom";

const LOGO_WHITE = "/brand/MFP_white.svg";
const YEAR = new Date().getFullYear();

export default function Footer({ onOpenCookieSettings }) {
  return (
    <footer
      className="relative bg-mfp-bg border-t border-mfp-gold/15 overflow-hidden"
      data-testid="site-footer"
    >
      {/* subtle gold gradient at top */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-mfp-gold/50 to-transparent"
      />
      {/* ambient glow */}
      <div
        aria-hidden="true"
        className="absolute -bottom-32 left-1/2 -translate-x-1/2 w-[40rem] h-[20rem] bg-mfp-gold/[0.04] blur-[120px] rounded-full pointer-events-none"
      />

      <div className="relative max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 md:gap-8">
          {/* Brand block */}
          <div className="flex flex-col gap-4 max-w-md">
            <img
              src={LOGO_WHITE}
              alt="MediaFly Production"
              width="160"
              height="40"
              className="h-10 w-auto"
              loading="lazy"
            />
            <p className="text-sm text-mfp-muted leading-relaxed">
              Cinematic Social Media &amp; Reel Production aus dem Rhein-Main-Gebiet.
            </p>
            <div
              className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] uppercase tracking-[0.22em] text-mfp-gold font-semibold"
              data-testid="footer-geo"
            >
              <span>Frankfurt</span>
              <span className="text-mfp-gold/40">·</span>
              <span>Aschaffenburg</span>
              <span className="text-mfp-gold/40">·</span>
              <span>Darmstadt</span>
              <span className="text-mfp-gold/40">·</span>
              <span>Rhein-Main</span>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex flex-col gap-3 text-xs uppercase tracking-[0.18em] text-mfp-muted">
            <div className="text-mfp-gold/80 font-bold mb-1">Legal</div>
            <Link to="/impressum" className="hover:text-mfp-champagne transition-colors" data-testid="footer-impressum">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-mfp-champagne transition-colors" data-testid="footer-datenschutz">
              Datenschutz
            </Link>
            <button
              type="button"
              onClick={onOpenCookieSettings}
              className="text-left hover:text-mfp-champagne transition-colors"
              data-testid="footer-cookie-settings"
            >
              Cookie-Einstellungen
            </button>
            <Link to="/admin/login" className="hover:text-mfp-champagne transition-colors" data-testid="footer-admin-login">
              Admin
            </Link>
          </nav>
        </div>

        {/* Divider */}
        <div className="mt-10 md:mt-14 mb-6 h-px bg-gradient-to-r from-transparent via-mfp-gold/15 to-transparent" />

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-mfp-muted">
          <span className="tracking-wide">
            © {YEAR} MediaFly Production. Alle Rechte vorbehalten.
          </span>
          <span className="tracking-wide">Emre Ucar · Babenhausen · Deutschland</span>
        </div>

        {/* Subtle build credit */}
        <div
          className="mt-6 text-center md:text-right text-[10px] tracking-[0.18em] uppercase"
          data-testid="footer-credit"
        >
          <a
            href="https://bamediaperformance.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-mfp-champagne/40 hover:text-mfp-gold/70 transition-colors duration-300 no-underline"
            data-testid="footer-credit-link"
          >
            Website-System by BA Media Performance
          </a>
        </div>
      </div>
    </footer>
  );
}
